import React, { Component, Fragment } from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

import appStyles from '../../../App/app.module.css';
import cssStyles from '../resetPassword.module.css';
import { FormControl } from '@material-ui/core';

const styles = (theme: Theme) => createStyles({
  btn: {
    margin: '10px 10px'
  },
  ex: {
    padding: 0
  },
  button: {
    height: '50px',
    marginTop: '14px'
  }
});

interface ResetPasswordCodeModalContainerProps {
  open: boolean;
  pin: string;
  disableCodeFields: boolean;
  classes: any;
  onChange: (e: any) => void;
  onVerification: (e: any) => void;
};


class ResetPasswordCodeModalContainer extends Component<ResetPasswordCodeModalContainerProps> {

  render() {
    if(!this.props.open)
      return '';

    return (
      <Fragment>
        <hr />
        <div className={cssStyles.row}>
          <div className={cssStyles.col}>
            <form className={appStyles.col} >
              <FormControl>
                <TextField
                  name='pin'
                  label="Enter the verification code"
                  margin="normal"
                  variant="outlined"
                  required
                  disabled={this.props.disableCodeFields}
                  fullWidth={true}
                  value={this.props.pin}
                  onChange={this.props.onChange}
                  InputLabelProps={{ shrink: true }}
                />
                <Button className={this.props.classes.btn} disabled={this.props.disableCodeFields} onClick={this.props.onVerification} color='primary' variant="contained">Verify</Button>
              </FormControl>
            </form>
          </div>
        </div>
      </Fragment>
    );
  }

};

export default withStyles(styles)(ResetPasswordCodeModalContainer);